import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const PreviewDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Heading = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 4fr 1fr 2fr 2fr 1fr;
  grid-row-gap: 0;
  grid-column-gap: 10px;
`;

export const PreviewRow = styled.div`
  width: 100%;
  height: 42px;
  display: grid;
  grid-template-columns: 1fr 4fr 1fr 2fr 2fr 1fr;
  grid-row-gap: 0;
  grid-column-gap: 10px;

  background-color: #f5f7fb;
  border-radius: 8px;
  padding-left: 12px;
  gap: 10px;

  font-size: 14px;
  font-weight: 400;
  color: #474d66;

  align-items: center;
`;

interface IPreviewText {
  limitOfLines?: number;
}

export const PreviewText = styled.div<IPreviewText>`
  font-size: 14px;
  font-weight: 400;
  color: #474d66;

  &.date {
    padding-left: 9px;
  }

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const Placeholder = styled.div`
  width: 100%;
  height: 10px;
  border-radius: 5px;
  background-color: #d8dae5;
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #8f95b2;

  height: 28px;
  padding: 0 12px 10px 12px;

  &.from {
    margin-left: -10.5px;
  }
`;

export const HolderDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8.75px;
  align-items: center;
  justify-content: center;
  margin-left: -29px;
`;

export const Internal = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1371fe;
`;

interface ITags {
  background?: string;
  color?: string;
}

export const Tags = styled.div<ITags>`
  display: flex;
  padding: 4px 12px 4px 12px;
  border-radius: 15px;
  height: 30px;
  background: ${({ background }) => background || '#edeff4'};
  color: ${({ color }) => color || '#474d66'};
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const TagCount = styled.div`
  display: flex;
  padding: 4px 12px 4px 12px;
  border-radius: 15px;
  height: 30px;
  background-color: #edeff4;
  font-size: 14px;
  font-weight: 500;
  color: #474d66;
  margin-left: 8px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 4px;
`;

export const Icon = styled.div`
  height: 20px;
`;
